import React from "react";
import { Link } from "react-router-dom";
import ErrorBoundary from "MODULES/shared/components/ErrorBoundary";
import Table from "./Table";

export default function RepairOrders() {
  return (
    <div>
      <h2>
        <Link to={`${location.pathname}/repair-order-line-items`}>
          Repair Orders <i className="text-muted fa fa-fw fa-list-ol" />
        </Link>
      </h2>
      <ErrorBoundary>
        <Table />
      </ErrorBoundary>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairOrders/RepairOrders.jsx